import React from 'react'

const TercerPaso = ({estado}) => {
    return (
        <>
            {estado !== '3' ? (
                <>
                    <p>El proceso de asignación de vacantes se realizará el 28/12/2023.</p>
                    <p>Una vez terminado el sorteo será informado de los resultados.</p>
                    <p>Por favor, sepa entender que estamos haciendo lo posible para lograr un sorteo justo para todos.</p>
                </>
            ) : ( 
                <>
                    <p>El proceso de asignación de vacantes correspondiente al primer llamado se realizó el 26/11/2024.</p>
                </>
            )}
        </>
    )
}

export default TercerPaso;